import { useEffect } from 'react'
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { useUser } from '@clerk/clerk-react'
import { Loader2 } from 'lucide-react'
import { AuthenticatedLayout } from '@/components/layout/authenticated-layout'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/sign-in',
        search: {
          redirect: location.href,
        },
      })
    }
  },
  component: AuthenticatedWrapper,
})

// Component wrapper to check domain restriction
function AuthenticatedWrapper() {
  const navigate = useNavigate()
  const { user, isLoaded: userLoaded } = useUser()

  useEffect(() => {
    // Check domain restriction once user is loaded
    if (userLoaded && user) {
      const email =
        user.primaryEmailAddress?.emailAddress ||
        user.emailAddresses?.[0]?.emailAddress ||
        ''

      if (email && !email.endsWith('@yhangry.com')) {
        navigate({ to: '/sign-in', replace: true })
      }
    }
  }, [userLoaded, user, navigate])

  // Show loading while user object is loading
  if (!userLoaded || !user) {
    return (
      <div className='flex h-svh items-center justify-center'>
        <Loader2 className='size-8 animate-spin' />
      </div>
    )
  }

  // Check domain in component
  const email =
    user.primaryEmailAddress?.emailAddress ||
    user.emailAddresses?.[0]?.emailAddress ||
    ''

  if (email && !email.endsWith('@yhangry.com')) {
    // Will redirect via useEffect, show loading
    return (
      <div className='flex h-svh items-center justify-center'>
        <Loader2 className='size-8 animate-spin' />
      </div>
    )
  }

  return <AuthenticatedLayout />
}
